// src/api/assetAssignLogApi.js
import apiClient from './axios';

const assetAssignLogApi = {
  getAll: async (page = 1, pageSize = 20, search = '', asset_assign ='') => {
    const response = await apiClient.get('/asset-assign-logs/', {
      params: {
        page,
        page_size: pageSize,
        search: search.trim() || undefined,
        asset_assign: asset_assign || undefined,
      },
    });
    return response.data;
  },
};

export default assetAssignLogApi;